import React from "react";
import { FormattedMessage } from "react-intl";

export const splitDateTime = (value, locale = "pt-PT") => {
  if (!value && value !== 0) return { date: null, time: null };
  const d =
    value instanceof Date ? value :
    typeof value === "number" ? new Date(value) :
    new Date(String(value));
  if (isNaN(d.getTime())) return { date: null, time: null };

  return {
    date: d.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" }),
    time: d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" }),
  };
};

/**
 * Props:
 * - iso: string|Date|number    // lastRefreshedAt
 * - version?: string           // refreshVersion
 * - className?: string         // classes extra (ex.: "mt-3")
 * - locale?: string            // default "pt-PT"
 * - idPrefix?: string          // default "indicators" (para i18n ids)
 * - as?: "div" | "span"        // default "div"
 */
export default function LastUpdate({
  iso,
  version,
  showVersion = true,
  className = "",
  locale = "pt-PT",
  idPrefix = "indicators",
  as: Tag = "div",
}) {
  const { date, time } = splitDateTime(iso, locale);

  if (!date || !time) {
    return (
      <Tag className={`text-start text-muted ${className}`}>
        <FormattedMessage
          id={`${idPrefix}.lastUpdate.unknown`}
          defaultMessage="Última atualização: n/d"
        />
      </Tag>
    );
  }

  return (
    <Tag className={`text-start text-muted ${className}`}>
      <FormattedMessage
        id={`${idPrefix}.lastUpdate`}
        defaultMessage="Última atualização"
      />
      : {date} <span>às</span> {time}
    </Tag>
  );
}
